import { ChangeDetectorRef, Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { BaseLicenseCheckboxItemComponent } from '@nimbus-library/features/shared/components/material/input-license/base/base-license-checkbox-item.component';

@Directive()
export abstract class BaseUserInputLicenseCheckboxItemComponent extends BaseLicenseCheckboxItemComponent {
  @Input() public label: string;
  @Input() public value: string;
  @Input() public isDisabledByParent: boolean = false;
  @Input() public isReadonly: boolean = false;

  @Output()
  public selectionChange: EventEmitter<string> = new EventEmitter<string>();

  protected readonly disabledReasonsMessage = TranslationKeys.SettingsFormDisabledReasonUsingLicenseNotPossible;

  public get isDisabled(): boolean {
    return this.isDisabledByParent || this.isDisabledByLicensesReasons;
  }

  public ICONS = ICONS;
  public TranslationKeys = TranslationKeys;

  public constructor(
    protected readonly changeDetectionRef: ChangeDetectorRef,
    protected readonly loggerService: ILogger,
    protected readonly translateService: TranslateService,
  ) {
    super(translateService, loggerService);
  }

  @HostListener('click')
  public onClick(): void {
    if (this.isDisabled || this.isReadonly) {
      return;
    }

    this.recalculateLicensesOnClick();

    this.selectionChange.emit(this.value);
  }
}
